// LEAVING A LOADED LOCATION — his rule, 2026-10-08: *"if they try to leave any other way with a
// location loaded: 'ROW 4 still loaded — 7 parts put away. Tap NEXT LOCATION or DONE.' Nothing is
// lost either way, it just stops anyone forgetting."*
//
// The floor shell's logo and the Desk/Floor toggle are in OTHER components, so the screen that
// has a location loaded registers a guard here and those exits ask it first. One tiny module, no
// context, no re-renders: the guard is a function or nothing at all.
let guard = null;

export function setLeaveGuard(fn) {
  guard = fn;
}

export function clearLeaveGuard(fn) {
  if (guard === fn) guard = null;
}

// Returns true when the caller may leave; false when the guard handled it (alert shown).
export function tryLeave(go) {
  if (guard) {
    guard();
    return false;
  }
  go?.();
  return true;
}
